module.exports = __webpack_public_path__ + "static/media/AIG seguros.ccc016aa.jpg";